import {CHANGE_BACKGROUND_FOR_OTHER_SIDES} from "../constants/action-types";

export const changeBgColorForOtherSides = (color) => ({
  type: CHANGE_BACKGROUND_FOR_OTHER_SIDES,
  payload: {
    color
  }
});
